import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{
    
    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { setLoadingSubmitForm } = globalStates
        const { validatePassword } = Helpers

        const { FormUser } = Forms
        const { formState, onResetForm } = FormUser

        if (formState.userPassword.includes(' ')){
            const messageCustom = {
                message: 'La contraseña no puede tener espacios',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const passValidate = validatePassword(formState.userPassword)
        if (passValidate.success === false) {
            const messageCustom = {
                message: passValidate.message,
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        if (formState.userPassword !== formState.userConfirmPassword) {
            const messageCustom = {
                message: 'Las contraseñas no coinciden, por favor, verifique que haya ingresado correctamente su contraseña',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const _dataBody = {
            idusuario: user.uid,
            userPassword: formState.userPassword,
            user: user.username
        }

        setLoadingSubmitForm(true)
        await marvarApi.put( `/users/change-password/${_dataBody.idusuario}`, _dataBody )
            .then(({ data }) => {

                alertMessage(data)
                onResetForm()
                setLoadingSubmitForm(false)

            })
            .catch(error => {
                console.log('API ERROR: ', error)
                setLoadingSubmitForm(false)
            })
    }

    return Object.freeze({
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}